import { HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { Observable } from "rxjs";

export const TimeZoneInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
    const headers = req.headers.set("Time-Zone", Intl.DateTimeFormat().resolvedOptions().timeZone);
    const newReq = req.clone({ headers });
    return next(newReq);
};
